module.exports = "/images/MB.png?30d45c454c2e005d13985923cf80fa60";